export enum PasswordErrorType {
  PasswordUsedRecently = 'PASSWORD_NOT_ALLOWED',
}
